import {
  Component,
  Input,
  OnInit,
  EventEmitter,
  Output,
  ViewChild,
  ElementRef
} from '@angular/core';

@Component({
  selector: 'app-tabnav',
  templateUrl: './tabnav.component.html',
  styleUrls: ['./tabnav.component.scss']
})

export class TabnavComponent implements OnInit {

  @ViewChild('nav') navElement: ElementRef;
  @ViewChild('navContainer') navContainerElement: ElementRef;
  @ViewChild('navListItem') navListElement: ElementRef;
  @ViewChild('showMore') showMoreElement: ElementRef;
  @ViewChild('overflowList') overflowListElem : ElementRef;


  @Output() activeItemChanged: EventEmitter<any> = new EventEmitter();
  @Input() menuItems = [
    {'label': 'Eschborn', 'container':'0-eschborn', 'active': true, 'animDirection': 'right'},
    {'label': 'Frankfurt', 'container':'1-frankfurt', 'active': false, 'animDirection': 'right'},
  ];

  scrollPosition: number = 0;
  scrollAnimationInProgress = false;
  navItemsTotalWidth: number = 0;
  navItemsContainerWidth: number = 0;

  ngOnInit() {


  }

  ngAfterViewInit() {
    this.detectOverflow();
  }

  itemClick(containerID: string) {
    this.activateItem(containerID);
  }


  activateItem(containerID: string) {

    const activeItem = this.menuItems.filter(opt => opt.active)[0];
    const newItem = this.menuItems.filter(opt => opt.container === containerID)[0];
    const activeIndex = this.menuItems.indexOf(activeItem);
    const newIndex = this.menuItems.indexOf(newItem);

    if ( activeIndex === newIndex ) { return; }

    if (activeIndex < newIndex) {
      activeItem.animDirection = 'right';
      newItem.animDirection = 'left';
    } else {
      activeItem.animDirection = 'left';
      newItem.animDirection = 'right';
    }

    activeItem.active = false;
    newItem.active = true;

    this.activeItemChanged.emit(containerID);

  }

  detectOverflow() {

     const navItems = this.navElement.nativeElement.querySelectorAll('li');
     this.navItemsContainerWidth = this.overflowListElem.nativeElement.clientWidth;

     for (let element of this.navElement.nativeElement.querySelectorAll('li')) {
       this.navItemsTotalWidth += element.clientWidth;
     }

     if(this.navItemsTotalWidth > this.navItemsContainerWidth) {
       this.navElement.nativeElement.classList.add('has-overflow')
     }

  }

  scrollTo(position: number) {

    if ( this.scrollAnimationInProgress === true ) { 

      return; 

    } else {

      const options = {
        element: this.overflowListElem.nativeElement,
        horizontal: true,
        cancelOnUserAction: true,
        onComplete: () => { this.scrollAnimationInProgress = false; }
      };

      // animateScrollTo(position, options);

    }

  }

  scrollOverflow() {
    this.scrollTo(this.navItemsTotalWidth);
  }


  getScrollPosition() {
    
     this.scrollPosition = this.overflowListElem.nativeElement.scrollLeft;
    
     if (this.scrollPosition > (this.navItemsTotalWidth - this.navItemsContainerWidth)) {

       this.showMoreElement.nativeElement.style.display = "none";

     } else {

       this.showMoreElement.nativeElement.style.display = "block";

     }
  }

}
